<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='客户移交'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='450'
      >
        <template v-slot:content>
           <v-card class="px-5" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-user-select :show-user='2' filled rounded dense  :rules="array" label="接收人选择" v-model='form.contactsPersonList'></v-user-select>
                </v-col>
              </v-row>

            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" rounded :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>

          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { move } from '@/api/customer/index.js'
  import VUserSelect from '@/components/select/v-user-select.vue'

  export default {
    name: 'CustomerMove',
    components: {
      VUserSelect
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        array: [
          value => value.length > 0 || '此项为必填项!'
        ],
        form: {
          id: '',
          contactsPersons: '',
          contactsPersonList: []
        }
      }
    },
    methods: {
      save () {
        this.form.contactsPersons = JSON.stringify(this.form.contactsPersonList)
        if (this.$refs.form.validate()) {
          this.loading = true
          move(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form.id = this.item.data.id
          }
        } else {
          this.$refs.form.reset()
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
